var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.0001 17.35C12.9003 17.35 13.6301 16.6202 13.6301 15.72C13.6301 14.8198 12.9003 14.09 12.0001 14.09C11.0999 14.09 10.3701 14.8198 10.3701 15.72C10.3701 16.6202 11.0999 17.35 12.0001 17.35Z",
    fill: "#D6EDFF",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.65 9.44H7.35C3.25 9.44 2 10.69 2 14.79V16.65C2 20.75 3.25 22 7.35 22H16.65C20.75 22 22 20.75 22 16.65V14.79C22 10.69 20.75 9.44 16.65 9.44ZM12 18.74C10.33 18.74 8.98 17.38 8.98 15.72C8.98 14.06 10.33 12.7 12 12.7C13.67 12.7 15.02 14.06 15.02 15.72C15.02 17.38 13.67 18.74 12 18.74Z",
    fill: "#D6EDFF",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.11997 9.45V8.28C7.11997 5.35 7.94997 3.4 12 3.4C16.05 3.4 16.88 5.35 16.88 8.28V9.45C17.39 9.46 17.85 9.48 18.28 9.54V8.28C18.28 5.58 17.63 2 12 2C6.36997 2 5.71997 5.58 5.71997 8.28V9.53C6.13997 9.48 6.60997 9.45 7.11997 9.45Z",
    fill: "#D6EDFF",
    fillOpacity: 0.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.a14be55c362730dfb8f433b407677f7e.svg";
export { ForwardRef as ReactComponent };